import { ReactNode } from 'react';

export const HeaderIconSize = {
  Size56: '56x56',
  Size48: '48x48',
  Size40: '40x40',
  Size36: '36x36',
  Size32: '32x32',
} as const;

export type HeaderIconSize = (typeof HeaderIconSize)[keyof typeof HeaderIconSize];

export const HeaderIconDefaultSize = HeaderIconSize.Size56;

export const HeaderIconMode = {
  ActionItem: 'actionItem',
  Timesheet: 'timesheet',
  AdminActionItem: 'adminActionItem',
  AdminTimesheet: 'adminTimesheet',
  Object: 'object',
  Library: 'library',
} as const;

export type HeaderIconMode = (typeof HeaderIconMode)[keyof typeof HeaderIconMode];

export type HeaderIconProps = {
  icon: ReactNode;
  mode?: HeaderIconMode;
  size?: HeaderIconSize;
  isFullScreenModalIcon?: boolean;
};
